module.exports = __webpack_public_path__ + "img/bg03.f83016cd.png";